// hooks/useAuth.js
export function useAuth() {
  const token = localStorage.getItem("token");
  const userRaw = localStorage.getItem("user");
  let user = null;
  let isTokenValid = false;

  try {
    user = JSON.parse(userRaw);

    if (token) {
      const payload = JSON.parse(atob(token.split(".")[1]));
      const exp = payload.exp;
      const now = Math.floor(Date.now() / 1000);

      if (exp && exp > now) {
        isTokenValid = true;
      } else {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        user = null;
      }
    }
  } catch (e) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    user = null;
  }

  const accountType = user?.account_type;

  return {
    isAuthenticated: isTokenValid && !!user,
    accountType,
    isPersonal: accountType === "personal",
    isBusiness: accountType === "business",
    user,
  };
}
